export const SIGNUP_ENDPOINT_URL: string = '/api/account/registration/';
export const SIGNIN_ENDPOINT_URL: string = '/api/account/login/';
export const SIGNUP_EMAIL_ENDPOINT_URL = '/api/users/signups/';
export const FACEBOOK_REGISTER_ENDPOINT_URL: string =
  '/api/account/facebook/login/';
export const GOOGLE_REGISTER_ENDPOINT_URL: string =
  '/api/account/google/login/';
export const USER_SESSION_ENDPOINT_URL = '/api/sessions/current/';
